//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import DashboardSidebar from '../components/Sidebars/DashboardSidebar' ;
import DashboardHeader from '../components/Headers/DashboardHeader' ;
import DashboardFooter from '../components/Footers/DashboardFooter' ;
import DashboardSettingsDrawer from '../components/Sidebars/DashboardSettingsDrawer' ;

export default ({
	components: {
		DashboardSidebar,
		DashboardHeader,
		DashboardFooter,
		DashboardSettingsDrawer,
	},
	data() {
		return {
			// Sidebar collapsed status.
			sidebarCollapsed: false,
			
			// Main sidebar color.
			sidebarColor: "primary",
			
			// Main sidebar theme : light, white, dark.
			sidebarTheme: "light",

			// Header fixed status.
			navbarFixed: false,

			// Settings drawer visiblility status.
			showSettingsDrawer: false,
		}
	},
	methods: {
		toggleSidebar( value ) {
			this.sidebarCollapsed = value ;
		},
		toggleSettingsDrawer( value ) {
			this.showSettingsDrawer = value ;
		},
		toggleNavbarPosition( value ) {
			this.navbarFixed = value ;
		},
		updateSidebarTheme( value ) {
			this.sidebarTheme = value ;
		},
		updateSidebarColor( value ) {
			this.sidebarColor = value ;
		},
	},
	computed: {
		// Sets layout's element's class based on route's meta data.
		layoutClass() {
			return this.$route.meta.layoutClass ;
		}
	},
})

